module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAUAgMAAACCKJcoAAAACVBMVEUAh1Go1sT///9VVME5AAAAFUlEQVQI12NgYGCQWrVqCQMEDCsmALxfKWlrTwRxAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./client/src/images/flags/ng.png
// module id = 897
// module chunks = 0